<script>
import { getLegalDocumentUrl } from '@fr/constants';
import { CookieConsent } from "@travelata-libs/ui-shared";

function getCookieDomain() {
  if (typeof window === 'undefined') return '';
  const { hostname } = window.location;
  const parts = hostname.split('.');
  if (parts.length === 2) {
    return `.${hostname}`;
  }
  return `.${parts.slice(-2).join('.')}`;
}

export default {
  name: "CookieConsentPopup",
  components: { CookieConsent },
  props: {
    cookieName: {
      type: String,
      default: "cookie_consent_accepted",
    },
    cookieValue: {
      type: String,
      default: "true",
    },
    image: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    domain() {
      return getCookieDomain();
    },
    cookiesUrl() {
      return getLegalDocumentUrl('cookies_agreement');
    },
    recommendationTechnologyUrl() {
      return getLegalDocumentUrl('recommendation_technologies_agreement');
    },
    personalDataAgreementUrl() {
      return getLegalDocumentUrl('personal_data_visitor_consent');
    },
    privacyPolicyUrl() {
      return getLegalDocumentUrl('privacy');
    }
  }
};
</script>

<template>
  <CookieConsent
    :cookie-name="cookieName"
    :cookie-value="cookieValue"
    :cookies-url="cookiesUrl"
    :recommendation-technology-url="recommendationTechnologyUrl"
    :personal-data-agreement-url="personalDataAgreementUrl"
    :privacy-policy-url="privacyPolicyUrl"
    :image="image"
    :domain="domain"
  />
</template>

<style scoped lang="scss">
::v-deep .tl-cookie-consent__link {
  color: #059bce;
}

::v-deep .tl-cookie-consent__link:hover {
  color: #04769c;
}

.tl-cookie-consent {
  @media (max-width: 768px) {
    bottom: 84px;
  }
}
</style>
